Oskari.lazyBundle('mobileuserguide', function() {return import(/* webpackChunkName: "chunk_mobileuserguide" */ 'oskari-bundle!/home/jenkins/workspace/pti-frontend/application-folder/bundles/paikkatietoikkuna/mobileuserguide/index.js');});
